import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';

export type BootPhase = 'booting' | 'playbackReady' | 'libraryAllowed';

export interface BootPhaseState {
  phase: BootPhase;
}

const initialState: BootPhaseState = {
  phase: 'booting',
};

const bootPhaseSlice = createSlice({
  name: 'bootPhase',
  initialState,
  reducers: {
    setPlaybackReady(state) {
      if (state.phase === 'booting') {
        state.phase = 'playbackReady';
      }
    },
    setLibraryAllowed(state) {
      state.phase = 'libraryAllowed';
    },
    setPhase(state, action: PayloadAction<BootPhase>) {
      // For explicit overrides/testing; only allow forward progress.
      const next = action.payload;
      const order: Record<BootPhase, number> = {
        booting: 0,
        playbackReady: 1,
        libraryAllowed: 2,
      };
      if (order[next] >= order[state.phase]) {
        state.phase = next;
      }
    },
  },
});

export const bootPhaseActions = bootPhaseSlice.actions;

export const selectBootPhase = (state: RootState) => state.bootPhase.phase;
export const selectAllowLibraryNetwork = (state: RootState) =>
  state.bootPhase.phase === 'libraryAllowed';

export default bootPhaseSlice.reducer;
